import { relations, sql } from 'drizzle-orm'
import { pgTable, text, uniqueIndex } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getDateField,
  getIdReference,
  getMonetaryField,
} from '../common/utils'
import { cashAccounts } from './cashAccount'

// An observed closing balance for one account on one day. The forecast anchors
// on the latest one and sums events after it, so a later observation silently
// supersedes the account's opening balance.
export const cashBalances = pgTable(
  'cash_balances',
  {
    ...getBaseFields(),
    accountId: getIdReference(() => cashAccounts.id),
    date: getDateField().notNull(),
    balance: getMonetaryField().notNull(),
    source: text().notNull(), // 'fennoa:ledger' | 'bank'
  },
  (table) => [
    ...getBaseIndexes('cash_balances', table),
    uniqueIndex('cash_balances_account_date_unique_idx')
      .on(table.accountId, table.date)
      .where(sql`deleted_at IS NULL`),
  ],
)

export const cashBalancesRelations = relations(cashBalances, ({ one }) => ({
  account: one(cashAccounts, {
    fields: [cashBalances.accountId],
    references: [cashAccounts.id],
  }),
}))
